const DelhiData = [
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "Plot 153, Sector 25, Faridabad",
        Contact: "",
        Price: " ",
        Comments: " ",
        verficationDataTime: "3:00 PM, 27-04",
        vendorName: "KK Industrial Gases ",
    },
    
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "b93, MAyapuri Industrial area phase 1",
        Contact: "8285979176",
        Price: " ",
        Comments: " ",
        verficationDataTime: "05-05-2021  00:40:00",
        vendorName: "Vinayak Air Enterprise ",
    },
   
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "Plot no 809, second floor, 3rd 42C, sector",
        Contact: "9990691313  WhatsApp no.- 08700013641",
        Price: " ",
        Comments: " Oxygen Langar- will have to visit them, they will provide the patient with the oxygen ",
        verficationDataTime: "03-05-2021",
        vendorName: "Hemkunt Foundation ",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "sadhna enclave pancheel park",
        Contact: "8130184210",
        Price: " ",
        Comments: " ",
        verficationDataTime: "03-05-2021",
        vendorName: "gurudwara  ",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "lajpat nagar phase1,gurudwara singh sabha, krishna market",
        Contact: "8130184210",
        Price: " ",
        Comments: "  ",
        verficationDataTime: "",
        vendorName: "",
    },
     {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "Dilshad Garden, indirapuram",
        Contact: "9311202053 only whatsapp",
        Price: " ",
        Comments: "  ",
        verficationDataTime: "03-05-2021",
        vendorName: " ",
    }, 
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "lajpat nagar phase1,gurudwara singh sabha, krishna marketq",
        Contact: "8130184210",
        Price: " ",
        Comments: "  ",
        verficationDataTime: "03-05-2021",
        vendorName: "",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "The Art of Knowledge, behind Maruti Showroom, Pitampura",
        Contact: "9911758881",
        Price: " ",
        Comments: "  ",
        verficationDataTime: "03-05-2021",
        vendorName: "",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "Mundka, Delhi, opp metro pillar 560",
        Contact: "9057507489",
        Price: " ",
        Comments: "  ",
        verficationDataTime: "03-05-2021",
        vendorName: "",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "Agarwal gas. Plot 155, Khasa Number 3/4 pooth khurd , bawana road delhi",
        Contact: "9555913146",
        Price: " ",
        Comments: " only whatsapp, the numbers which are switched off, try whatsapping on them.",
        verficationDataTime: "03-05-2021",
        vendorName: "Docs  ID of the patient, Covid +ve report, ID of the person headed to refill the oxygen",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "Mayapuri- Delhi",
        Contact: "9837379080 , 8218831364",
        Price: " ",
        Comments: "Free Refilling",
        verficationDataTime: "03-05-2021",
        vendorName: "Mohit Mayapuri ",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "mundka industrial area, gali number 2, near sun computer lab",
        Contact: "9315236962",
        Price: " ",
        Comments: " ",
        verficationDataTime: "03-05-2021",
        vendorName: "Shyam Gas Company",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "art of living pitampura,near nexa showroom(kali mata mandir)",
        Contact: "",
        Price: " ",
        Comments: " ",
        verficationDataTime: "3rd may@ 2:30pm",
        vendorName: "Art of living - pitampura",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "Mundka Industrial Metro Station, Delhi",
        Contact: "",
        Price: " ",
        Comments: " ",
        verficationDataTime: "4th May, 12pm",
        vendorName: "shree sham gas, mundka industrial metro station",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "Delhi",
        Contact: "9911111313",
        Price: " ",
        Comments: "Free Oxygen refill ",
        verficationDataTime: "4th May, 3:45pm",
        vendorName: "Oxygen Refill free",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "Delhi- Turakman Gate",
        Contact: "9958701033",
        Price: " ",
        Comments: "Free Oxygen refill ",
        verficationDataTime: "4th May, 3:48pm",
        vendorName: "Oxygen Refill free",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "Keshorpur Mandir, Gate No.01, Delhi",
        Contact: "9057507489 , 8384072953 ",
        Price: " ",
        Comments: "Starts 11AM ",
        verficationDataTime: "4th May, 7:30PM",
        vendorName: "oxygen refill",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "Mundka. Opp pillar number557,560,Delhi",
        Contact: "",
        Price: " ",
        Comments: "10AM-1Pm ",
        verficationDataTime: "4th May, 7:30PM",
        vendorName: "oxygen refill",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "GK1 Pahadi wala gurudwara, Delhi",
        Contact: "8130184210",
        Price: "free",
        Comments: " Refilling 10-15ltrs",
        verficationDataTime: "4th May, 11:13pm",
        vendorName: "oxygen refill",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "Delhi",
        Contact: "9057507489",
        Price: " ",
        Comments: "WHATSAPP",
        verficationDataTime: "5th May",
        vendorName: "oxygen refill",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "Delhi",
        Contact: "9734908391 , 9953200032",
        Price: " ",
        Comments: "WHATSAPP ",
        verficationDataTime: "5th may",
        vendorName: "oxygen refill",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "opposite piller no. 560 mundka delhi ",
        Contact: "9057507489",
        Price: " ",
        Comments: "carry adhar card and doctor's priscription with you ",
        verficationDataTime: "7th may 8:20 am",
        vendorName: "oxygen refilling",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "gali qasim jaan, Ballimaran, old delhi",
        Contact: "9250515849",
        Price: " ",
        Comments: " ",
        verficationDataTime: "10:42 pm 7th may",
        vendorName: "oxygen refill",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "azadpur north delhi",
        Contact: "9971651619",
        Price: " free of cost",
        Comments: "10ltrs",
        verficationDataTime: "12:30 on 11th may",
        vendorName: "oxygen refilling",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "Delhi (moti nagar)",
        Contact: "9871067808",
        Price: " ",
        Comments: "",
        verficationDataTime: "02-05-2021  21:09:00",
        vendorName: "",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "mundka industrial area, gali number 2, near sun computer lab",
        Contact: "9315236962",
        Price: " ",
        Comments: "",
        verficationDataTime: "03-05-2021",
        vendorName: "Shyam Gas Company",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "Sadhna Enclave, Panchsheel Park, Delhi-110017",
        Contact: "8130184210",
        Price: "1.10L ",
        Comments: "",
        verficationDataTime: "9:40AM, 4 May",
        vendorName: "Gurudwara Dukh Bhanjan Bunga Sahib",
    },

    {
        City: "Delhi",
        nameOfResource: "oxygenRefill",
        Address: "Delhi NCR ghaziabad",
        Contact: "8445111146",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },

 
    {
        City: "Delhi",
        nameOfResource: "oxygenCylinder",
        Address: "delhi",
        Contact: "8103234402",
        Price: " ",
        Comments: " ",
        verficationDataTime: "02-05-2021  19:20:00",
        vendorName: "",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenCylinder",
        Address: "Delhi",
        Contact: "9312965950",
        Price: " ",
        Comments: " SWITCHED OFF",
        verficationDataTime: "02-05-2021",
        vendorName: "Amba Oxygen",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenCylinder",
        Address: "Vikaspuri, delhi",
        Contact: "9205101601",
        Price: "3500 / 12litre ",
        Comments: " ",
        verficationDataTime: "03-05-2021",
        vendorName: "",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenCylinder",
        Address: "Delhi",
        Contact: "9453597550",
        Price: "10l-12000, 30l-17000, 50l-30000 ",
        Comments: "Home Delivery ",
        verficationDataTime: "4th May, 10:12Am",
        vendorName: "Oxygen Cyl Home Delivery",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenCylinder",
        Address: "PD block dakshini pitampura",
        Contact: "9990180205",
        Price: " ",
        Comments: "Empty Cylinder ",
        verficationDataTime: "4th May, 12:50pm",
        vendorName: "pitampura delhi",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenCylinder",
        Address: "",
        Contact: "9213610932",
        Price: " 10ltrs- 26k",
        Comments: " ",
        verficationDataTime: "5th may 12:15pm",
        vendorName: "Empty Cylinder",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenCylinder",
        Address: "at in front of hira sweets bear v3s mall, laxmi nagar delhi",
        Contact: "8377893017",
        Price: "",
        Comments: " 10-15 kg cylinders only",
        verficationDataTime: "",
        vendorName: "oxygen refilling",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenCylinder",
        Address: "Delhi NCR- Gurgaon",
        Contact: "98913 32403",
        Price: "",
        Comments: " ",
        verficationDataTime: "",
        vendorName: "mohta brothers",
    },
    {
        City: "Delhi",
        nameOfResource: "oxygenCylinder",
        Address: "",
        Contact: "8882036300",
        Price: "",
        Comments: " ",
        verficationDataTime: "",
        vendorName: "",
    },


    {
        City: "Delhi",
        nameOfResource: "Oxygen",
        Address: "Delhi",
        Contact: "9650236000",
        Price: " ",
        Comments: " ",
        verficationDataTime: "02-05-2021",
        vendorName: " Aggarwal gases",
    },
    {
        City: "Delhi",
        nameOfResource: "Oxygen",
        Address: "Plot no 809, second floor, 3rd 42C, sector",
        Contact: "9990691313  WhatsApp no.- 08700013641",
        Price: " ",
        Comments: " Oxygen Langar- will have to visit them, they will provide the patient with the oxygen ",
        verficationDataTime: "03-05-2021",
        vendorName: "Hemkunt Foundation ",
    },
    {
        City: "Delhi",
        nameOfResource: "Oxygen",
        Address: "Opp pacific mall Subhash Nagar",
        Contact: "",
        Price: " ",
        Comments: " Free Oxygen Sewa",
        verficationDataTime: "03-05-2021",
        vendorName: "Tikona Park",
    },
    {
        City: "Delhi",
        nameOfResource: "Oxygen",
        Address: "CP- Delhi",
        Contact: "",
        Price: " ",
        Comments: "Free Oxygen Sewa ",
        verficationDataTime: "03-05-2021",
        vendorName: "Gurrdwara Rakaabganj Sahib",
    },
    {
        City: "Delhi",
        nameOfResource: "Oxygen",
        Address: "delhi",
        Contact: "9711170220",
        Price: " ",
        Comments: "8-1200 hrs ",
        verficationDataTime: "5th May",
        vendorName: "24 Hrs Oxygen Support",
    },
    {
        City: "Delhi",
        nameOfResource: "Oxygen",
        Address: "delhi",
        Contact: "8696496094",
        Price: " ",
        Comments: "12-1600 hrs ",
        verficationDataTime: "5th May",
        vendorName: "25 Hrs Oxygen Support",
    },
    {
        City: "Delhi",
        nameOfResource: "Oxygen",
        Address: "delhi",
        Contact: "8587834472",
        Price: " ",
        Comments: "16-2000 hrs ",
        verficationDataTime: "5th May",
        vendorName: "26 Hrs Oxygen Support",
    },
    {
        City: "Delhi",
        nameOfResource: "Oxygen",
        Address: "delhi",
        Contact: "8126654666",
        Price: " ",
        Comments: "20-2400 hrs",
        verficationDataTime: "5th May",
        vendorName: "27 Hrs Oxygen Support",
    },
    {
        City: "Delhi",
        nameOfResource: "Oxygen",
        Address: "delhi",
        Contact: "9654418883",
        Price: " ",
        Comments: "24-0400 hrs ",
        verficationDataTime: "5th May",
        vendorName: "28 Hrs Oxygen Support",
    },
    {
        City: "Delhi",
        nameOfResource: "Oxygen",
        Address: "delhi",
        Contact: "9873325428",
        Price: " ",
        Comments: "4-0800 hrs ",
        verficationDataTime: "5th May",
        vendorName: "29 Hrs Oxygen Support",
    },
    {
        City: "Delhi",
        nameOfResource: "Oxygen",
        Address: "Green apartment near Maharaja Agarsain Public School, Pitampura, New Delhi.",
        Contact: "8882036300",
        Price: " 10L @ ₹10,500",
        Comments: "DO NOT PAY IN ADVANCE.",
        verficationDataTime: " 17th May 4:40 a.m.",
        vendorName: "*OXYGEN CYLINDERS* - DELHI",
    },
    {
        
        City: "",
        nameOfResource: "Ambulance",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "Beds",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "bloodBanks",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "foodDistribution",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "homeCare",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "Medicines",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "resourceAgencies",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "womenInCardiology",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "humanSupporters",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
      
      {
    
        City: "",
        nameOfResource: "plasmaDonors",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },
    {
    
        City: "",
        nameOfResource: "testingCenters",
        Address: "",
        Contact: "",
        Price: " ",
        Comments: "",
        verficationDataTime: "",
        vendorName: "",
    },

];


export default DelhiData;